import React from 'react'
import styles from '../index.module.scss'
import InputCustom from '../../atoms/input/InputCustom'
import SelectCustom from '../../atoms/select/SelectCustom'
import { Grid } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { setSurveyData } from '../../../features/kazooEventSlice'
import GoogleAddressInput from '../../atoms/input/GoogleAddressInput'

const Florist = () => {
	const dispatch = useDispatch()
	const surveyData = useSelector((s) => s.kazooEvent.surveyData)
	const [data, setData] = React.useState({
		flowerDeliveryAddress: surveyData?.flowerDeliveryAddress || '',
	})

	const handlePlaceSelected = (placeData) => {
		dispatch(setSurveyData({
			flowerDeliveryAddress: placeData.formattedAddress,
		}))
		setData({
			...data,
			flowerDeliveryAddress: placeData.formattedAddress,
		})
	}
	
	/* TODO: uncomment when implemented  */
	const handleChange = (e) => {
		dispatch(
			setSurveyData({
				[e.target.name]: e.target.value,
			})
		)
	}
	
	return (
		<>
			<div>
				<h3 className={styles.Title}>Florist Survey</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="companyContactName"
								className={styles.label}
							>
								Company contact name
							</label>
							<InputCustom
								id="companyContactName"
								name="companyContactName"
								placeholder="Enter Company contact name"
								value={surveyData?.companyContactName || ''}
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="companyContactNumber"
								className={styles.label}
							>
								Company Contact Number
							</label>
							<InputCustom
								id="companyContactNumber"
								name="companyContactNumber"
								placeholder="Enter Company Contact Number"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="flowerDeliveryAddress"
								className={styles.label}
							>
								Flower delivery address
							</label>
							<GoogleAddressInput
								data-cy="flowerDeliveryAddress"
								placeholder="Enter flower delivery address"
								name="flowerDeliveryAddress"
								id="flowerDeliveryAddress"
								value={data?.flowerDeliveryAddress}
								setDataFunction={setData}
								data={data}
								onPlaceSelected={handlePlaceSelected}
								required={true}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="numberOfArrangements"
								className={styles.label}
							>
								Number of arrangements
							</label>
							<InputCustom
								id="numberOfArrangements"
								name="numberOfArrangements"
								placeholder="e.g., bouquets, boutonnieres, centerpieces, etc."
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="whoReceivesDeliveries"
								className={styles.label}
							>
								Who receives deliveries?
							</label>
							<InputCustom
								id="whoReceivesDeliveries"
								name="whoReceivesDeliveries"
								placeholder="Enter"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="whoReceivesDeliveries"
								className={styles.label}
							>
								Any rentals included in quote?
							</label>
							<SelectCustom
								label="Select"
								options={[
									{ value: 'Yes', label: 'Yes' },
									{ value: 'No', label: 'No' },
								]}
							></SelectCustom>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Timeline Details</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="deliveryTime"
								className={styles.label}
							>
								Delivery time
							</label>
							<InputCustom
								id="deliveryTime"
								name="deliveryTime"
								placeholder="Enter delivery time"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="setupStartTime"
								className={styles.label}
							>
								Setup start time
							</label>
							<InputCustom
								id="setupStartTime"
								name="setupStartTime"
								placeholder="Enter setup start time"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="setupDuration"
								className={styles.label}
							>
								Setup duration
							</label>
							<InputCustom
								id="setupDuration"
								name="setupDuration"
								placeholder="Enter setup duration"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="teardownPickupTime"
								className={styles.label}
							>
								Teardown/pickup time (if applicable)
							</label>
							<InputCustom
								id="teardownPickupTime"
								name="teardownPickupTime"
								placeholder="Enter teardown/pickup time"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Dependencies</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="coordinationWithVendorCategories"
								className={styles.label}
							>
								Coordination with vendor categories?
							</label>
							<SelectCustom
								id="coordinationWithVendorCategories"
								name="coordinationWithVendorCategories"
								label="Select"
								options={[
									{ value: 'Yes', label: 'Yes' },
									{ value: 'No', label: 'No' },
								]}
							></SelectCustom>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="refrigerationOrStorageRequirements"
								className={styles.label}
							>
								Refrigeration or storage requirements?
							</label>
							<InputCustom
								id="refrigerationOrStorageRequirements"
								name="refrigerationOrStorageRequirements"
								placeholder="Enter"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Notes</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="uploadMockupsOrInspirationBoards"
								className={styles.label}
							>
								Upload mockups or inspiration boards (optional)
							</label>
							<InputCustom
								id="uploadMockupsOrInspirationBoards"
								name="uploadMockupsOrInspirationBoards"
								placeholder="Enter notes"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Other Questions</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="rainContingencyOrSetupChangeNeeded"
								className={styles.label}
							>
								Rain contingency or setup change needed?
							</label>
							<InputCustom
								id="rainContingencyOrSetupChangeNeeded"
								name="rainContingencyOrSetupChangeNeeded"
								placeholder="Enter details"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="setupTeardownDuration"
								className={styles.label}
							>
								Setup / teardown duration
							</label>
							<InputCustom
								id="setupTeardownDuration"
								name="setupTeardownDuration"
								placeholder="Enter details"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="specialEquipmentOrSpaceNeeds"
								className={styles.label}
							>
								Special equipment or space needs?
							</label>
							<InputCustom
								id="specialEquipmentOrSpaceNeeds"
								name="specialEquipmentOrSpaceNeeds"
								placeholder="Enter details"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="contactForDayOfEmergencies"
								className={styles.label}
							>
								Contact for day-of emergencies
							</label>
							<InputCustom
								id="contactForDayOfEmergencies"
								name="contactForDayOfEmergencies"
								placeholder="Enter contact for day-of emergencies"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
		</>
	)
}

export default Florist
